import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const allowedLangs = ["en", "es", "ca", "de", "fr", "ru", "pl"];
const normalizeLanguage = (value) => String(value || "").toLowerCase().split("-")[0];
const userLang = normalizeLanguage(localStorage.getItem("i18nextLng") || navigator.language);
const selectedLang = allowedLangs.includes(userLang) ? userLang : "en";
const i18nVersion = encodeURIComponent([
  process.env.REACT_APP_RUNTIME_VERSION || process.env.REACT_APP_BUILD_VERSION || "dev",
  process.env.REACT_APP_GIT_COMMIT || "local",
].join(':'));

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: selectedLang,
    debug: false,
    supportedLngs: allowedLangs,
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    fallbackLng: "en",
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${i18nVersion}`,
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
      convertDetectedLanguage: normalizeLanguage,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
